<template>
  <tr class="hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors duration-200">
    <!-- Sipariş -->
    <td class="px-3 py-2">
      <span class="font-medium text-sm"># {{ item.orderNo }}</span>
    </td>
    
    <!-- Müşteri -->
    <td class="px-3 py-2">
      <span class="text-sm text-gray-700 dark:text-gray-300">{{ item.customer }}</span>
    </td>
    
    <!-- Miktar -->
    <td class="px-3 py-2">
      <span class="font-semibold text-blue-600">{{ item.amount }}</span>
      <span class="text-xs text-gray-500 ml-1">ton</span>
    </td>
    
    <!-- Rota -->
    <td class="px-3 py-2">
      <div class="text-xs text-gray-600 dark:text-gray-400 space-y-1">
        <div class="truncate max-w-32">🟢 {{ item.outpointAdress }}</div>
        <div class="truncate max-w-32">🔴 {{ item.targetAdress }}</div>
      </div>
    </td>
    
    <!-- Araç -->
    <td class="px-3 py-2">
      <span class="font-bold text-blue-600">{{ item.recomendedCount }}</span>
    </td>
    
    <!-- Tür -->
    <td class="px-3 py-2">
      <select 
        :value="item.haveType"
        @change="(event) => $emit('update-vehicle-type', { index, value: event.target.value })"
        class="text-xs border border-gray-300 rounded px-1 py-1 w-full max-w-20"
      >
        <option value="3">Hepsi</option>
        <option value="1">Kiralık</option>
        <option value="2">Özmal</option>
      </select>
    </td>
    
    <!-- Mesafe -->
    <td class="px-3 py-2">
      <div class="text-xs space-y-1">
        <div>{{ item.kilometer }}km</div>
        <div class="text-gray-500">{{ (item.time / 60).toFixed(1) }}h</div>
      </div>
    </td>
    
    <!-- Tarih -->
    <td class="px-3 py-2">
      <span class="text-xs">{{ item.deliveryDate | dateFilter }}</span>
    </td>
    
    <!-- İşlemler -->
    <td class="px-3 py-2">
      <button
        type="button"
        class="w-8 h-8 bg-red-500 hover:bg-red-600 text-white rounded-md transition-colors duration-200 flex items-center justify-center"
        @click="$emit('delete-order', index)"
      >
        <i class="fas fa-trash text-xs"></i>
      </button>
    </td>
  </tr>
</template>

<script>
import diffInput from "@/components/general/diffInput.vue";
import moment from "moment";

export default {
  name: "OrderRow",
  components: {
    diffInput,
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      vehicleTypeOptions: [
        { id: 3, name: 'Hepsi' },
        { id: 1, name: 'Kiralık' },
        { id: 2, name: 'Özmal' },
      ]
    };
  },
  filters: {
    dateFilter(val) {
      return moment(val).format("DD/MM/YYYY HH:mm");
    },
  },
};
</script>